<template>
  <div class="x-login-sms-code">
    <XFormItem prop="msgCode" label="验证码">
      <ElInput ref="input" v-model="model.smsCode" placeholder="请输入验证码" maxlength="6">
        <template v-slot:suffix>
          <ElButton @click="sendSmsCode"
                    :loading="loading"
                    :disabled="disabled"
                    class="x-login-mobile-number__sms"
                    type="text">
            {{smsCodeButtonText}}
          </ElButton>
        </template>
      </ElInput>
    </XFormItem>
    <XFormItem prop="imageCode" label="图形验证码" v-if="showImageVerify">
      <ElInput v-model="model.imageCode" @change="handleImageCodeChange" placeholder="请输入图形验证码" maxlength="4">
        <template v-slot:suffix>
          <div @click="updateVerifyUrl" class="x-password-sms__code">
            <img :src="verifyUrl" alt="">
          </div>
        </template>
      </ElInput>
    </XFormItem>
  </div>
</template>

<script>
import {
  Input as ElInput,
  Button as ElButton
} from 'element-ui';
import {uuid} from '@/util/util';
import {stringify} from '@/util/url';
// import { sendSmsCodeApi } from '../../../api/passwordApi';
const sendSmsCodeApi = () => {};
export default {
  components: {
    ElInput,
    ElButton
  },
  props: {
    phone: String,
    buttonText: {
      type: String,
      default: '获取验证码'
    },
    reSendButtonText: {
      type: String,
      default: '重新获取'
    },
    // 获取验证码接口地址
    verify: {
      type: [String, Function],
      default: '/api/user/verifyImage.jpg'
    },
    limit: {
      type: Number,
      default: 60
    },
    value: String
  },
  data() {
    return {
      verifyUrl: '',
      verifyId: '',
      showImageVerify: false,
      model: {
        smsCode: this.value,
        imageCode: ''
      },
      counter: 0,
      disabled: false,
      loading: false,
      hasSend: false
    };
  },
  computed: {
    smsCodeButtonText() {
      return this.hasSend
        ? this.reSendButtonText + ' ' + (this.disabled ? this.counter : '')
        : this.buttonText;
    }
  },
  watch: {
    showImageVerify: {
      immediate: true,
      handler(val) {
        val && this.updateVerifyUrl();
      }
    },
    'model.smsCode'(val) {
      this.$emit('input', val);
    },
    value: {
      immediate: true,
      handler(val) {
        this.model.smsCode = val;
      }
    }
  },
  methods: {
    updateVerifyUrl() {
      if (!this.verify) return null;
      this.verifyId = uuid();
      const query = {
        uuid: this.verifyId,
        w: 200,
        h: 80
      };
      this.verifyUrl = typeof this.verify === 'function'
        ? this.verify(query)
        : this.verify + '?' + stringify(query);
    },
    sendSmsCode() {
      if (!this.validate()) return;
      const {phone, model, verifyId} = this;
      this.loading = true;
      sendSmsCodeApi({
        phone: phone,
        imageCode: model.imageCode,
        imageUuid: verifyId,
        msgCode: 'SmsCodeEntryApply',
        reSendToken: ''
      }).then(res => {
        this.showImageVerify = false;
        this.disabled = true;
        this.counter = this.limit;
        this.hasSend = true;
        this.ticking();
      }).catch(e => {
        const msg = e.msg || e.message || '未知错误';
        this.$notify({
          message: msg,
          type: 'error'
        });
        if (e.code === 506) {
          this.showImageVerify = true;
        }
        this.disabled = false;
      }).finally(_ => {
        this.loading = false;
      });
    },
    ticking() {
      this.timer = setTimeout(() => {
        --this.counter;
        if (this.counter > 0) {
          this.ticking();
        } else {
          this.disabled = false;
        }
      }, 1000);
    },
    validate() {
      const {phone, showImageVerify, model} = this;
      if (showImageVerify && model.imageCode.length < 4) {
        this.$notify({
          message: '请输入图形验证码',
          type: 'error'
        });
        return false;
      }
      return true;
    },
    handleImageCodeChange() {
      const code = this.model.imageCode;
      if (code && code.length === 4) {
        this.sendSmsCode();
      }
    }
  },
  beforeDestroy() {
    this.timer && clearTimeout(this.timer);
  }
};
</script>
